export default __webpack_public_path__ + "static/media/stuck-veskovic-poolbau-4.47e81176.jpg";